import { inputVariant } from "@babackapp/ui/components/input";
import { cn } from "@babackapp/ui/lib/utils";
import { forwardRef, useRef, useState } from "react";
import FormInputContainer from "./form-input-container";

type FormColorPickerProps = {
  label: string;
  description?: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean | string;
};

const FormColorInput = forwardRef(
  (
    { label, description, value, onChange, disabled }: FormColorPickerProps,
    ref,
  ) => {
    void ref;
    void ref;
    const [focused, setFocused] = useState(false);
    const picker = useRef<HTMLInputElement>(null);

    const onClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      e.preventDefault();
      e.stopPropagation();
      picker.current?.click();
    };

    return (
      <FormInputContainer
        label={label}
        description={description}
        disabled={disabled}
      >
        <div className="relative">
          <input
            ref={picker}
            onFocus={() => setFocused(true)}
            onBlur={() => setFocused(false)}
            type="color"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            disabled={!!disabled}
            className="h-0"
          />
          <button
            role="button"
            onClick={onClick}
            className={cn(
              inputVariant,
              "absolute flex items-center gap-2 inset-0",
              focused &&
                "ring-2 ring-offset-background ring-offset-2 ring-ring",
            )}
          >
            <div
              className="w-6 h-6 rounded-full"
              style={{ backgroundColor: value }}
            />
            <span className="text-muted-foreground semibold text-sm">
              {value}
            </span>
          </button>
        </div>
      </FormInputContainer>
    );
  },
);

FormColorInput.displayName = "FormColorInput";

export default FormColorInput;
